import React from 'react';

import PageHero from '@/components/PageHero';
import DifferentiatorsSection from '@/components/DifferentiatorsSection';
import CallToActionSection from '@/components/CallToActionSection';

const WhyAltax: React.FC = () => {
  return (
    <>
      <PageHero 
        title="Why Choose Alta-X"
        subtitle="A transparent, modern approach to building wealth through alternative investments."
        backgroundImage="https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      />
      
      <main className="flex-grow">
        <DifferentiatorsSection />
        <CallToActionSection />
      </main>
    </>
  );
};

export default WhyAltax;
